export default {
	scroller: true,
};
